import React, { useEffect, useState } from "react";
import Image from "./Image";
import Select from "react-select";

function CustomDropDown({
  name,
  register,
  labelTitle,
  placeholder,
  icon,
  setValue,
  showError,
  errorMessage,
  options,
  showMandatory = false,
  defaultOption,
  parentProps,
  resetValue,
  onChange,
  setResetValue,
  customValue,
  setCustomValue,
  labelClass,
  Dropdownclass,
  ...props
}) {
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  useEffect(() => {
    if (resetValue) {
      setResetValue(false);
      setSelectedOption(null);
    }
  }, [resetValue]);

  useEffect(() => {
    if (customValue) {
      setCustomValue(null);
      setSelectedOption(customValue);
      if (setValue) setValue(name, customValue.value, { shouldValidate: true });
    }
  }, [customValue]);

  return (
    <div className={`form-group mb-3 d-flex flex-column ${Dropdownclass}`} {...parentProps}>
     <label className={`login_heading ${labelClass}`}>
        {labelTitle}
        {showMandatory ? <span className="danger">*</span> : null}
      </label>
      <div className="position-relative">
        <Image src={icon} className="input_icons"></Image>
        <Select
          defaultValue={selectedOption}
          maxMenuHeight={200}
          onChange={(e) => {
            if (setValue) setValue(name, e.value, { shouldValidate: true });
            if (onChange) onChange(e)
            setSelectedOption(e);
          }}
          value={selectedOption}
          // {...(register ? register(name) : {})}
          {...props}
          placeholder={placeholder}
          noOptionsMessage={() => "No Data Available!"}
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              borderColor: "#e2e2e2",
            }),
            valueContainer: (baseStyles, state) => ({
              ...baseStyles,
              padding: "6px 16px",
              fontSize: "14px",
              fontWeight: "400",
            }),
            menu: (baseStyles, state) => ({
              ...baseStyles,
              zIndex: 999,
            }),
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 8,
            colors: {
              ...theme.colors,
              primary25: "#e2e2e2",
              primary: "#14489F",
              neutral90: "#FFFFFF",
            },
          })}
          options={options}
        />
      </div>

      {showError ? (
        <span className="danger fs-14 fw-400 mt-1">{errorMessage}</span>
      ) : null}
    </div>
  );
}

export default CustomDropDown;
